import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import Modal from '../../components/Modal/Modal';
import Button from '@mui/material/Button';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import TextField from '@mui/material/TextField'
import FormLabel from '@mui/material/FormLabel';
import { Card, CardContent, Checkbox, FormHelperText, IconButton, Typography } from '@mui/material';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Link, useNavigate } from 'react-router-dom';
import styles from './FormularioRelatorio.module.css';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { styled } from '@mui/material/styles';
import { telefoneMascara, telefoneSemMascara, cpfMascara, cpfSemMascara } from '../../util/mascaras';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import Head from '../../helper/Head';
import formularioRelatorio from './service/formularioRelatorio.service';
import { ClipboardText } from "@phosphor-icons/react";
import copy from "copy-to-clipboard";
import Toast from '../../components/Toast/Toast';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { env } from '../../../env/env';
import ProgressoCircular from '../../components/ProgressoCircular/ProgressoCircular';
import { useTranslation } from 'react-i18next';


const urlBack: string = (env.baseURL as string);

export default function FormularioRelatorio() {
   const { register, handleSubmit, watch, setValue, clearErrors, setError, formState: { errors } } = useForm();
   const { t } = useTranslation();

   const [openModal, setOpenModal] = useState(false);
   const [errorMsg, setErrorMsg] = useState(false);
   const [isDisabled, setIsDisabled] = useState(false);


   const [estadoOcorrenciaList, setEstadoOcorrenciaList] = useState([] as any);
   const [estadoOcorrencia, setEstadoOcorrencia] = useState('');
   const [cidadeOcorrenciaList, setCidadeOcorrenciaList] = useState([] as any);
   const [cidadeOcorrencia, setCidadeOcorrencia] = useState('');

   const [grupoTrabalhoList, setGrupoTrabalhoList] = useState([] as any);
   const [grupoTrabalhoOutros, setGrupoTrabalhoOutros] = useState(false);

   const [hasOtherGenre, setHasOtherGenre] = useState(false);


   const anoAtual = new Date().getFullYear();

   const navigate = useNavigate();

   const [isCheckboxChecked, setIsCheckboxChecked] = useState(true);

  
   const handleCheckboxChange = (e: any) => {
      setIsCheckboxChecked(e.target.checked);
   };

   

   useEffect(() => {
      fetch('https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome')
         .then((response) => response.json())
         .then((data) => setEstadoOcorrenciaList(data));
   }, []);

   useEffect(() => {
      if (!!estadoOcorrencia) {
         fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${estadoOcorrencia}/municipios?orderBy=nome`)
            .then((response) => response.json())
            .then((data) => setCidadeOcorrenciaList(data));
      }
   }, [estadoOcorrencia]);


   useEffect(() => {
      (async () => {
         const data = await formularioRelatorio.getGrupoTrabalho();
         setGrupoTrabalhoList(data);
      })()
   }, []);
 
  

   const handleChangeEstadoOcorrencia = (event: SelectChangeEvent) => {
      clearErrors('estadoOcorrencia');
      setEstadoOcorrencia(event.target.value);

      estadoOcorrenciaList.forEach((e: any) => {
         if (e.id == event.target.value)
            setValue('estadoOcorrencia', e.nome);
      });
   };

   const handleChangeCidadeOcorrencia = (event: SelectChangeEvent) => {
      clearErrors('cidadeOcorrencia');
      setCidadeOcorrencia(event.target.value);

      cidadeOcorrenciaList.forEach((e: any) => {
         if (e.id == event.target.value)
            setValue('cidadeOcorrencia', e.nome);
      });
   };

   
      
   
   //Submit
   const onSubmit = async (data: any) => {   
      
      if(data.genero == 'Outros') {
         data.genero = data.outroGenero;
         delete data.outroGenero;        
      }   
     
      
      //if (!data.grupoTrabalho) data.grupoTrabalho = [];

      //Criando Cookie com os parametros de pesquisa
      //Grupo de trabalho foi passado para json para poder ser gravado no cookies
      localStorage.setItem('genero', data.genero);
      localStorage.setItem('dtInicial', data.dtInicial);
      localStorage.setItem('dtFinal', data.dtFinal);

      if (!data.grupoTrabalho) data.grupoTrabalho = 0;
      else{
         const arGrupoTrabalho = JSON.stringify(data.grupoTrabalho);
         localStorage.setItem('grupoTrabalho', arGrupoTrabalho);
         data.grupoTrabalho = arGrupoTrabalho;
      }   

      const resp = await formularioRelatorio.geraRelatorio(data);
      navigate('/list-gera-relatorio/');         
   }

   const handleCheckBox = (e: any) => {
      const nome = e.target.value.split(',');

      if (nome[1] == 'Outros' && e.target.checked) {
         setGrupoTrabalhoOutros(true)
      }
      else if (nome[1] == 'Outros' && !e.target.checked) {
         setGrupoTrabalhoOutros(false)
         setValue('grupoTrabalhoOutros', '');
      }
      clearErrors('grupoTrabalho');
   }

   const handleGenero = (e: any) => {
      setValue('genero', e.target.value)
      if (e.target.value === 'Outros') {
         setHasOtherGenre(true);
      } else {
         setHasOtherGenre(false);
         setValue('outroGenero', '');
      }
   }

   const handleVerificaDataInicial = (e: any) => {
      const dataAnoInserida = e.target.value.split('-')[0];

      if (dataAnoInserida < anoAtual) {
         setError('dtInicial', { message: 'Insira uma data deste ano!' });
         setValue('dtInicial', '');
      } else {
         clearErrors('dtInicial')
      }
   }

   const handleVerificaDataFinal = (e: any) => {
      const dataAnoInserida = e.target.value.split('-')[0];

      if (dataAnoInserida < anoAtual) {
         setError('dtFinal', { message: 'Insira uma data deste ano!' });
         setValue('dtFinal', '');
      } else {
         clearErrors('dtFinal')
      }
   }




   return (
      <section className="background-section background-full">


         <Head title=" | Gerar relatório" />
         <div className={`animeRight container`}>
            <div className={styles.sectionTitle}>
               <h1 className={styles.title}>
                  
                  <br/>
                  
               </h1>
               <h2 className={styles.subtitle}></h2>
            </div>
            <div className={styles.formContainer}>
               <Card>
                  <CardContent>
                  <h2 className="section-title">Gerar relatório</h2>

                     <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
                     
                        <div className={styles.grid}> 

                           

                        <FormControl >

                              <InputLabel>{t('genero')}</InputLabel>
                              <input {...register('genero', { required: false })} hidden />
                              <Select
                                 // value={sexo}
                                 label={t('genero')}
                                 // onChange={handleSexo}
                                 // onChange={(e: any) => setSexo(e.target.value), (e: any) => setValue('sexo', e.target.value)}
                                 onChange={handleGenero}
                                 MenuProps={{ PaperProps: { sx: { maxHeight: 450 } } }}
                              >
                                 <MenuItem value="Homem">Homem</MenuItem>
                                 <MenuItem value="Mulher">Mulher</MenuItem>
                                 <MenuItem value="Outros">Outros</MenuItem>
                              </Select>
                           </FormControl>

                        </div>
                        <div className={styles.grid} hidden={! hasOtherGenre}>

                           <FormControl >
                              <TextField
                                 {...register('outroGenero')}
                                 label={t('outroGenero')}
                                 variant="outlined"
                                 type='text'
                                 error={errors.outroGenero ? true : false}
                              //helperText={errors.telefoneRequerente && 'Campo Telefone está vazio!'}
                              />
                           </FormControl>

                        </div>

                        <div className={styles.grid}>
                           <TextField
                              {...register('dtInicial', { required: false })}
                              label={t('Data inicial')}
                              type="date"
                              onBlur={handleVerificaDataInicial}
                              InputLabelProps={{ shrink: true }}
                              inputProps={{ min: `${anoAtual}-01-01`, max: '9999-12-31' }}
                              error={errors.dtInicial ? true : false}
                              helperText={errors.dtInicial && errors.dtInicial.message?.toString()}
                           />
                            <TextField
                              {...register('dtFinal', { required: false })}
                              label={t('Data final')}
                              type="date"
                              onBlur={handleVerificaDataFinal}
                              InputLabelProps={{ shrink: true }}
                              inputProps={{ min: `${anoAtual}-01-01`, max: '9999-12-31' }}
                              error={errors.dtFinal ? true : false}
                              helperText={errors.dtFinal && errors.dtFinal.message?.toString()}
                           />
                        </div>


                        <div>
                           <FormControl error={errors.grupoTrabalho ? true : false}>
                              <FormLabel>
                                 {t('textoTema')}
                              </FormLabel>

                              <div className='col'>
                                 {grupoTrabalhoList.length > 0 &&
                                    <>
                                       {grupoTrabalhoList.map((e: any, i: any) => (
                                          <div key={i}>
                                             <FormControlLabel
                                                {...register(`grupoTrabalho`, { required: false })}
                                                control={<Checkbox
                                                   style={{ color: errors.grupoTrabalho ? 'red' : '' }}
                                                   value={[e.idGrupoTrabalho]}
                                                   onChange={handleCheckBox}
                                                />}
                                                label={''}
                                             />
                                             {<span style={{ color: errors.grupoTrabalho ? 'red' : '' }}>
                                              {t(e.atividade)}
                                             </span>
                                             }
                                          </div>
                                       ))}

                                       {(grupoTrabalhoOutros) &&
                                          <TextField
                                             {...register('grupoTrabalhoOutros', { required: false })}
                                             label={t('grupoTrabalhoOutros')}
                                             variant="outlined"
                                             type='text'
                                             error={errors.grupoTrabalhoOutros ? true : false}
                                             helperText={errors.grupoTrabalhoOutros && "Campo de outros esta vazio!"}
                                          />
                                       }
                                       {errors.grupoTrabalho &&
                                          <FormHelperText>{errors.grupoTrabalho.message?.toString()}</FormHelperText>
                                       }
                                    </>
                                 }
                              </div>
                           </FormControl>

                        </div>



                        <div className={styles.formButton}>
                           <Button variant="contained" type='submit'>
                              {t('Gerar relatório')}
                           </Button>
                        </div>


                     </form>
                  </CardContent>
               </Card>
            </div>
         </div>
         

      

      </section>
   )
}
